import { queryOptions, useQuery } from '@tanstack/react-query';
import { LoopPlannerSchedulesApi } from '@/features/planner/api/schedules';
import { plannerQueryKeys } from '@/features/planner/queryKeys';

export const bulkFetchSchedulesQueryOptions = ({
  loopId,
  scenarioId,
  itemIds,
  enabled = true,
  staleTime,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  enabled?: boolean;
  staleTime?: number;
}) =>
  queryOptions({
    queryKey: plannerQueryKeys.schedules.bulkFetch({ loopId, scenarioId, itemIds }),
    queryFn: () => LoopPlannerSchedulesApi.bulkFetch({ loopId, scenarioId, itemIds }),
    enabled: enabled && itemIds.length > 0,
    ...(staleTime !== undefined && { staleTime }),
  });

export const useBulkFetchSchedules = ({
  loopId,
  scenarioId,
  itemIds,
  enabled,
  staleTime,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  enabled?: boolean;
  staleTime?: number;
}) => {
  return useQuery(
    bulkFetchSchedulesQueryOptions({ loopId, scenarioId, itemIds, enabled, staleTime }),
  );
};
